import React, { useEffect, useState } from "react";
import { useAuthStore } from "../../store/useStore";
import PageHeader from "../../components/common/PageHeader";
import { getReleases, saveRelease } from "./operationsApi";
import { Workspace } from "./styles";

const initial = { enabled: false, latestVersion: "0.0.2", latestBuild: 14, minimumVersion: "0.0.2", minimumBuild: 14, storeUrl: "", message: "안정적인 서비스 이용을 위해 앱을 업데이트해주세요." };
export function ReleaseForm({ platform, record, token, onSaved }) {
  const [form, setForm] = useState(record || initial);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const change = (key, value) => setForm(current => ({ ...current, [key]: value }));
  async function submit(event) {
    event.preventDefault(); setError("");
    if (form.enabled && !window.confirm(`${platform === "ios" ? "iOS" : "Android"} ${form.minimumVersion} (${form.minimumBuild}) 미만의 앱 이용이 차단됩니다. 이 버전이 스토어에 출시되어 있는지 확인하셨나요?`)) return;
    setBusy(true);
    try {
      const body = Object.fromEntries(Object.keys(initial).map(key => [key, form[key]]));
      await saveRelease(token, platform, body); onSaved();
    } catch (e) { setError(e.message); } finally { setBusy(false); }
  }
  return <form onSubmit={submit}><fieldset disabled={busy}><legend>{platform === "ios" ? "iOS" : "Android"}</legend>
    <label><input type="checkbox" checked={form.enabled} onChange={e => change("enabled", e.target.checked)} />최소 지원 버전 검사 활성화</label>
    {[["latestVersion", "최신 버전"], ["minimumVersion", "최소 지원 버전"]].map(([key, label]) => <label key={key}>{label}<input required pattern="(0|[1-9][0-9]{0,4})\.(0|[1-9][0-9]{0,4})\.(0|[1-9][0-9]{0,4})" value={form[key]} onChange={e => change(key, e.target.value)} placeholder="1.2.3" /></label>)}
    {[["latestBuild", "최신 빌드 번호"], ["minimumBuild", "최소 지원 빌드 번호"]].map(([key, label]) => <label key={key}>{label}<input type="number" min="1" max="2147483647" required value={form[key]} onChange={e => change(key, Number(e.target.value))} /></label>)}
    <label>공식 스토어 주소<input type="url" required={form.enabled} value={form.storeUrl} onChange={e => change("storeUrl", e.target.value)} placeholder={platform === "ios" ? "https://apps.apple.com/…/id…" : "https://play.google.com/store/apps/details?id=…"} /></label>
    <label>업데이트 안내 문구<textarea maxLength={300} value={form.message} onChange={e => change("message", e.target.value)} /></label>
    {error && <p role="alert">{error}</p>}<button className="primary" type="submit">{busy ? "저장 중…" : "설정 저장"}</button>
  </fieldset></form>;
}
export default function AppReleases() {
  const token = useAuthStore(s => s.token);
  const [records, setRecords] = useState(null); const [error, setError] = useState(""); const [notice, setNotice] = useState("");
  useEffect(() => {
    let active = true;
    getReleases(token).then(result => { if (active) setRecords(result.data); }).catch(e => { if (active) setError(e.message); });
    return () => { active = false; };
  }, [token]);
  return <><PageHeader title="앱 버전 관리" /><Workspace>
    <p>Android·iOS의 최신 버전과 최소 지원 버전을 각각 관리합니다. 최소 지원 버전 미만에서는 업데이트 전까지 앱 화면 이용이 차단됩니다. 동일 버전은 빌드 번호로 비교합니다.</p>
    <p>스토어 심사가 완료되고 실제 업데이트가 가능한 버전만 활성화해주세요. 이 기능이 포함되지 않은 구버전 앱에는 차단 화면을 소급 적용할 수 없습니다.</p>
    {error && <p role="alert">{error}</p>}{notice && <p role="status">{notice}</p>}
    {!records && !error && <p role="status">설정을 불러오는 중…</p>}
    {records && <div className="forms">{["android", "ios"].map(platform => <ReleaseForm key={`${token}-${platform}`} platform={platform} token={token} record={records.find(r => r.platform === platform)} onSaved={() => setNotice("저장했습니다. 앱 시작 또는 화면 복귀 시 확인합니다.")} />)}</div>}
  </Workspace></>;
}
